import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import Moment from 'moment-timezone';
// import Moment from 'moment';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { Popup } from 'components/Popup/popup';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Textarea from '../../components/react-validation/components/text-area';
import { AppSettings } from '../../constants';
import SignatureCanvas from 'react-signature-canvas';
import {connect} from 'react-redux';
import * as WorkOrderActionType from '../constants';
import * as CommonActionType from 'Common/constants';
class ResolvePopup extends React.Component {
  static propTypes = {
    onSaveResolvePopup: PropTypes.func,
    onCancelResolvePopup: PropTypes.func,
    WorkOrderProfile: PropTypes.object,
    dispatch: PropTypes.func,
    rfsId: PropTypes.string,
    workOrderId: PropTypes.string,
    WorkOrderCredentials: PropTypes.any,
    onCheckHomeownerSignatureWO: PropTypes.func,
    checkHomeownerWO: PropTypes.bool,
    UploadSuccess: PropTypes.bool,
    onCheckUploadFile: PropTypes.func,
    onResetCheckUploadFile: PropTypes.func,
    isAccordion: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = {
      lastResolvedDate: Moment().format('MM/DD/YYYY'),
      error: null,
      homeownerSignatureUrl: null,
      homeownerSignature: null,
      signatureStatus: this.props.UploadSuccess
    };
  }

  componentDidMount() {
    this.props.onCheckHomeownerSignatureWO();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.UploadSuccess !== this.props.UploadSuccess) {
      this.setState({
        signatureStatus: nextProps.UploadSuccess
      });
    }
  }

  onChangeDate = (lastResolvedDate) => {
    if (lastResolvedDate) {
      // If it's a Moment object (selected from calendar), it's always valid
      if (Moment.isMoment(lastResolvedDate)) {
        this.setState({
          lastResolvedDate: lastResolvedDate,
          error: null
        });
      } else if (typeof lastResolvedDate === 'string') {
        // Keyboard input: update the value and only validate when fully typed (MM/DD/YYYY = 10 chars)
        if (lastResolvedDate.length >= 10) {
          if (Moment(lastResolvedDate, 'MM/DD/YYYY', true).isValid()) {
            this.setState({
              lastResolvedDate: Moment(lastResolvedDate, 'MM/DD/YYYY'),
              error: null
            });
          } else {
            this.setState({
              lastResolvedDate: lastResolvedDate,
              error: 'Invalid datetime. Please use mm/dd/yyyy format.'
            });
          }
        } else {
          // Still typing, update value without error
          this.setState({
            lastResolvedDate: lastResolvedDate,
            error: null
          });
        }
      }
    } else {
      this.setState({
        lastResolvedDate: lastResolvedDate
      });
    }
  }

  onSaveHomeownerSignature = () => {
    this.setState({
      homeownerSignature: this.homeownerSignature
        .getTrimmedCanvas()
        .toDataURL('image/png')
    }, () => this.uploadHomeownerSignatureToS3());
  }

  onClearHomeownerSignature = () => {
    this.homeownerSignature.clear();
    this.setState({
      homeownerSignature: null,
      homeownerSignatureUrl: null
    }, () => {
      this.props.onResetCheckUploadFile();
    });
  }

  uploadHomeownerSignatureToS3 = () => {
    if (AppSettings.clientTypeValue === 'Builder') {
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: `/request-for-services/${this.props.rfsId}/work-order/${this.props.workOrderId}/detail/signatures`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo: this.props.workOrderId,
              rfsId: this.props.rfsId,
              data: this.state.homeownerSignature,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                // console.log(callbackData, 'callbackData');
                this.getHomeownerSignatureS3(callbackData);
              }
            }
          });
        }
      });
    } else {
      const {WorkOrderProfile: {builderProfile}} = this.props;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_SUBCONTRACTOR_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `/request-for-services/${this.props.rfsId}/work-order/${this.props.workOrderId}/detail/signatures`
          },
          endpoint: builderProfile.s3SredentialsEndpoint,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        },
        callback: () => {
          this.props.dispatch({
            type: WorkOrderActionType.UPLOAD_SIGNATURE_WORK_ORDER_ASYNC,
            params: {
              refNo: this.props.workOrderId,
              config: this.props.WorkOrderCredentials,
              data: this.state.homeownerSignature
            },
            // callback: this.getHomeownerSignatureS3(signature)
            callback: (status, callbackData) => {
              if (status === true) {
                this.getHomeownerSignatureS3(callbackData);
              }
            }
          });
        }
      });
    }
  }

  getHomeownerSignatureS3 = (callbackData) => {
    this.setState({
      homeownerSignatureUrl: callbackData.data.Location
    },() => {
      this.props.onCheckUploadFile();
    });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {homeownerSignatureUrl} = this.state;
    const homeownerSignature = homeownerSignatureUrl;
    // console.log(homeownerSignature, 'homeownerSignature');
    const { comment } = this.form.getValues();
    let {selectedDate} = this.lastResolvedDate.state;
    this.props.onSaveResolvePopup(formatTimezoneDateTime(selectedDate), comment, homeownerSignature);
  }

  render() {
    // console.log(this.state.signatureStatus, 'upload status');
    const UploadDisabled = !this.state.lastResolvedDate || this.state.error || !this.state.signatureStatus;
    const disabled = !this.state.lastResolvedDate || this.state.error;
    return (
      <Popup ref={(ref) => { this.resolvePopup = ref; }}
        isHasFaded={true}
        className='resolve-popup'
        styles={{
          width: this.props.isAccordion == true ? 350 : 450,
          top: this.state.error ? -380 : -355,
          left: 60,
          paddingTop: this.props.isAccordion == true ? 0 : 20
        }}>
        <Form ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
          <div className='form-group' style={{marginBottom: 0}}>
            <div className='col-sm-12 col-xs-12'>
              <span
                className='col-xs-12' style={{paddingLeft: 5, color: '#444', lineHeight: '40px'}}>Last resolved</span>
              <div className='col-xs-12' style={{padding: 0}}>
                <Datetime
                  ref={ref => { this.lastResolvedDate = ref; }}
                  inputProps={{ placeholder: 'mm/dd/yyyy', readOnly: false }}
                  value={this.state.lastResolvedDate}
                  timeFormat={false}
                  onChange={this.onChangeDate} 
                  closeOnSelect={true}/>
                {this.state.error &&
                    <span className='text-danger' style={{fontSize: 12}}>{this.state.error}</span>
                }
              </div>
            </div>
          </div>
          <div className='form-group' style={{marginBottom: 0}}>
            <div className='col-sm-12 col-xs-12'>
              <span
                className='col-xs-12' style={{paddingLeft: 5, color: '#444', lineHeight: '40px'}}>Comment <span style={{opacity: 0.5}}>(optional)</span></span>
              <div className='col-xs-12' style={{padding: 0}}>
                <Textarea
                  name='comment'
                  ref='comment'
                  className='form-control'
                  maxLength='1000'
                  rows={this.props.isAccordion == true ? '2': '5'}
                />
              </div>
            </div>
          </div>
          {this.props.checkHomeownerWO === false && <div className='form-group' style={{marginBottom: 0}}>
            <div className='col-sm-12 col-xs-12'>
              <span
                className='col-xs-12' style={{paddingLeft: 5, color: '#444', lineHeight: '40px'}}>Homeowner signature <span style={{opacity: 0.5}}>(optional)</span></span>
              <div className='col-xs-12' style={{border: '1px solid lightgray', padding: 0}}>
                <button
                  style={{marginTop: 5, left: 'auto', right: 13, position: 'absolute', marginRight: -5}}
                  type='button'
                  className='close'
                  onClick={this.onClearHomeownerSignature}
                >&times;</button>
                <SignatureCanvas
                  penColor='black'
                  canvasProps={{
                    top: '-6px',
                    bottom: '15px',
                    right: '10px',
                    marginLeft: -15,
                    marginTop: 20,
                    width: 400,
                    border: '1px solid lightgray',
                    maxwidth: 450,
                    height: this.props.isAccordion == true ? 100 : 150
                  }}
                  className='homeownerSignature'
                  ref={ref => {
                    this.homeownerSignature = ref;
                  }}
                  onEnd={this.onSaveHomeownerSignature}
                />
              </div>
            </div>
          </div>}
          <ul className='wo-popup-bottom-btn' style={{marginTop: 0, borderTop: 0 }}>
            <li>
              <button
                type='button'
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.props.onCancelResolvePopup}>Cancel
              </button>
            </li>
            <li>
              <Submit
                className='btn btn-primary btn-siteone'
                disabled={this.state.homeownerSignature !== null ? UploadDisabled : disabled}>Save
              </Submit>
            </li>
          </ul>
        </Form>
      </Popup>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

export default connect(mapStateToProps)(ResolvePopup);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/ResolvePopup.js